import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { formatNumberWithDecimals } from '@/creditflowresearch/ui/components/deals/helpers';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => (
  tranche.weightedAverageLife
    ? formatNumberWithDecimals(tranche.weightedAverageLife, 2)
    : '-'
);

const WalCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="WalCell"
    className={ alignStyles.alignCenter }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default WalCell;
